'use strict';

// ----------------------------------------
// Private
// ----------------------------------------
let $link = $('.calculator-open');
let url;
let width;
let height;

// ----------------------------------------
// Public
// ----------------------------------------

function displayWindow () {
	$link.on('click', function () {
		url = $(this).data('url');
		width = $(this).data('width');
		height = $(this).data('height');
		console.log('hhhh');

		window.open(url, 'Calculation', 'width=' + width + ', height=' + height);
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {displayWindow};



// WEBPACK FOOTER //
// ./src/js/_modules/open-window.js